import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white text-black flex flex-col" data-testid="not-found-page">
      <div className="grain-overlay" aria-hidden="true" />
      <header className="border-b border-black">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="font-heading font-black text-lg tracking-tight" data-testid="notfound-brand">
            DOM<span className="text-[#FF4500]">.</span>LAFRANCE
          </Link>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-black/50">
            Error · 404
          </span>
        </div>
      </header>

      <main className="flex-1 flex items-center border-b border-black overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-12 py-20 w-full">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: EASE }}
          >
            <div className="label-eyebrow">Page not found</div>
            <h1 className="font-heading font-black leading-[0.82] tracking-tighter mt-6 text-[26vw] md:text-[20vw] lg:text-[16vw]">
              4<span className="text-[#FF4500]">0</span>4
            </h1>
            <p className="mt-8 max-w-xl text-lg text-black/70 leading-relaxed">
              This page took a market dip and disappeared. The link may be broken, or the
              content was moved. Let's get you back to solid ground.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/" className="btn-primary inline-flex items-center gap-2" data-testid="notfound-home-btn">
                <ArrowLeft className="w-4 h-4" /> Back home
              </Link>
              <Link to="/#connect" className="btn-secondary inline-flex items-center gap-2" data-testid="notfound-connect-btn">
                Talk to Dom <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>
        </div>
      </main>

      <footer className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-12 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-black/60">
        © {new Date().getFullYear()} Dom Lafrance · Dryden · Ontario
      </footer>
    </div>
  );
}
